/* tslint:disable */
/* eslint-disable */
/**
 * ELEMENTS API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface FinishUploadEndpointRequest
 */
export interface FinishUploadEndpointRequest {
    /**
     * 
     * @type {string}
     * @memberof FinishUploadEndpointRequest
     */
    uploadId?: string;
}

export function FinishUploadEndpointRequestFromJSON(json: any): FinishUploadEndpointRequest {
    return FinishUploadEndpointRequestFromJSONTyped(json, false);
}

export function FinishUploadEndpointRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): FinishUploadEndpointRequest {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'uploadId': !exists(json, 'upload_id') ? undefined : json['upload_id'],
    };
}

export function FinishUploadEndpointRequestToJSON(value?: FinishUploadEndpointRequest | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'upload_id': value.uploadId,
    };
}


